<div [formGroup]="formGroup">
  <table class="table table-striped">
    <thead>
      <tr>
        <th width="30%">SKU</th>
        <th>Original Price</th>
        <th>Quantity</th>
        <th>Unit <span class="text-danger">*</span></th>
        <th>Price</th>
        <th>Total</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody [formArrayName]="controlName">
      <tr
        *ngFor="let kitItem of kitItems.controls; let idx = index"
        [formGroupName]="idx"
      >
        <td class="sku-col-mw">
          <cnc-sku-kit-dropdown
            controlName="sku"
            (selectedItem)="addSelectedItem(idx, $event)"
            [isRfqs]="true"
            [rfqType]="productTypes.PRODUCT"
            [matTooltip]="showTooltip(item)"
            [matTooltipDisabled]="!showTooltip(item)"
            [matTooltipShowDelay]="1000"
            [addTag]="false"
            matTooltipPosition="above"
            [isInKitItemsComponent]="true"
            [sellableProducts]="true"
          ></cnc-sku-kit-dropdown>
        </td>
        <td class="text-right">
          <span class="form-control"> {{ kitItem.value.originalPrice }} </span>
        </td>
        <td>
          <input
            type="number"
            class="form-control text-right"
            formControlName="quantity"
            lumDecimalLimit
          />
        </td>
        <td>
          <ng-select
            [items]="
              kitItems.at(idx).value.sku && kitItems.at(idx).value.sku
                ? unitOfMeasures[kitItems.at(idx).value.sku.id]
                : []
            "
            formControlName="uomId"
            bindValue="id"
            bindLabel="name"
            [multiple]="false"
            [clearable]="false"
          >
          </ng-select>
        </td>
        <td>
          <input
            type="number"
            class="form-control text-right"
            formControlName="price"
          />
        </td>
        <td class="text-right">
          <span class="form-control">
            {{ kitItem.value.lineTotal | lumCurrency }}
          </span>
        </td>
        <td class="text-middle">
          <a
            href="javascript:void(0);"
            class="text-danger"
            (click)="removeItem(idx)"
          >
            <i class="fa fa-fw fa-times"></i>
          </a>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="5" class="text-right">Total Selling Price</td>
        <td class="text-right">{{ totalSellingPrice | lumCurrency }}</td>
      </tr>
      <tr>
        <td colspan="5" class="text-right">Total Original Price</td>
        <td class="text-right">{{ totalOriginalPrice | lumCurrency }}</td>
      </tr>
      <tr>
        <td colspan="6">
          <div ngbDropdown placement="top-right" container="body">
            <button
              class="lum-button lum-button--dotted lum-button--full-width"
              id="addItemsDropdown"
              ngbDropdownToggle
            >
              Add Item(s)
            </button>
            <div ngbDropdownMenu aria-labelledby="addItemsDropdown">
              <button ngbDropdownItem (click)="addItem()">Add 1 Item</button>
              <button ngbDropdownItem (click)="addMultipleItems(5)">
                Add 5 Items
              </button>
              <button ngbDropdownItem (click)="addMultipleItems(10)">
                Add 10 Items
              </button>
              <button ngbDropdownItem (click)="addMultipleItems(25)">
                Add 25 Items
              </button>
              <button ngbDropdownItem (click)="addMultipleItems(50)">
                Add 50 Items
              </button>
            </div>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
